/* LUNA theme — vanilla JS, no libraries */
(() => {
  'use strict';
  const d = document;
  const root = d.documentElement;
  root.classList.remove('no-js');
  const $ = (s, c = d) => c.querySelector(s);
  const $$ = (s, c = d) => Array.from(c.querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const LUNA = window.LUNA || {};
  const money = (cents) => {
    const v = (cents / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return v[0] + ',' + v[1] + ' zł';
  };

  /* ---------- focus trap + drawers ---------- */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
  let openLayer = null; let lastFocus = null;
  const overlay = $('#PageOverlay');
  function openDrawer(el, opts = {}) {
    if (!el) return;
    if (openLayer && openLayer !== el) closeDrawer(openLayer, true);
    lastFocus = opts.returnFocus || d.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) { overlay.classList.add('is-visible', 'page-overlay--dark'); }
    d.body.style.overflow = 'hidden';
    openLayer = el;
    setTimeout(() => { const f = $(FOCUSABLE, el); f && f.focus({ preventScroll: true }); }, 60);
    $$('[aria-controls="' + el.id + '"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
  }
  function closeDrawer(el, silent) {
    el = el || openLayer; if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible', 'page-overlay--dark');
    d.body.style.overflow = '';
    $$('[aria-controls="' + el.id + '"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    openLayer = null;
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.LunaDrawer = { open: openDrawer, close: closeDrawer };
  d.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if ($('.zoom.is-open')) return closeZoom();
      if (openLayer) return closeDrawer();
      closeSearch(); closeMega();
    }
    if (e.key === 'Tab' && openLayer) {
      const f = $$(FOCUSABLE, openLayer).filter(x => x.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  overlay && overlay.addEventListener('click', () => { if (openLayer) closeDrawer(); closeMega(); });
  d.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(d.getElementById(opener.dataset.drawerOpen), { returnFocus: opener }); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });

  /* ---------- announcement ---------- */
  $$('.announcement').forEach(bar => {
    const msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    let i = 0;
    setInterval(() => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, (parseInt(bar.dataset.speed, 10) || 5) * 1000);
  });

  /* ---------- header: hide on scroll, transparent over hero ---------- */
  const hw = $('.header-wrap');
  if (hw) {
    let lastY = window.scrollY; let ticking = false;
    const hero = $('.hero');
    const transparent = hw.dataset.transparent === 'true' && hero && d.body.classList.contains('template-index');
    if (transparent) { hw.classList.add('overlay-hero', 'is-transparent'); }
    const onScroll = () => {
      const y = window.scrollY;
      if (!$('.mega.is-open') && !$('.search-panel.is-open')) {
        if (y > 120 && y > lastY) { hw.classList.add('is-hidden'); d.body.classList.remove('header-visible'); }
        else if (y < lastY || y <= 120) { hw.classList.remove('is-hidden'); d.body.classList.add('header-visible'); }
      }
      if (transparent) {
        const past = y > (hero.offsetHeight - hw.offsetHeight - 10);
        hw.classList.toggle('is-transparent', !past && !$('.mega.is-open') && !$('.search-panel.is-open'));
      }
      lastY = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    d.body.classList.add('header-visible');
    onScroll();
  }
  const syncTransparent = () => {
    if (!hw || !hw.classList.contains('overlay-hero')) return;
    const hero = $('.hero');
    const open = $('.mega.is-open') || $('.search-panel.is-open');
    hw.classList.toggle('is-transparent', !open && hero && window.scrollY < hero.offsetHeight - hw.offsetHeight - 10);
  };

  /* ---------- mega menu ---------- */
  const mega = $('#MegaMenu');
  let megaOpenT, megaCloseT;
  function openMega() {
    if (!mega) return;
    clearTimeout(megaCloseT);
    mega.classList.add('is-open');
    overlay && overlay.classList.add('is-visible');
    $$('[data-mega-trigger]').forEach(t => t.setAttribute('aria-expanded', 'true'));
    syncTransparent();
  }
  function closeMega() {
    if (!mega || !mega.classList.contains('is-open')) return;
    mega.classList.remove('is-open');
    if (!openLayer) overlay && overlay.classList.remove('is-visible');
    $$('[data-mega-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
    syncTransparent();
  }
  if (mega) {
    const triggers = $$('[data-mega-trigger]');
    const zone = [mega, ...triggers];
    zone.forEach(z => {
      z.addEventListener('mouseenter', () => { clearTimeout(megaCloseT); megaOpenT = setTimeout(openMega, 150); });
      z.addEventListener('mouseleave', () => { clearTimeout(megaOpenT); megaCloseT = setTimeout(closeMega, 200); });
    });
    triggers.forEach(t => t.addEventListener('click', (e) => {
      e.preventDefault();
      mega.classList.contains('is-open') ? closeMega() : openMega();
      if (mega.classList.contains('is-open')) { const f = $('.mega__cat', mega); f && f.focus(); }
    }));
    const cats = $$('.mega__cat', mega);
    const select = (btn) => {
      cats.forEach(c => c.setAttribute('aria-selected', c === btn ? 'true' : 'false'));
      $$('.mega__panel', mega).forEach(p => p.classList.toggle('is-active', p.id === btn.getAttribute('aria-controls')));
    };
    cats.forEach(c => { c.addEventListener('mouseenter', () => select(c)); c.addEventListener('focus', () => select(c)); c.addEventListener('click', () => select(c)); });
    mega.addEventListener('focusout', (e) => { if (!mega.contains(e.relatedTarget) && !triggers.includes(e.relatedTarget)) closeMega(); });
  }

  /* ---------- mobile menu sub levels ---------- */
  d.addEventListener('click', (e) => {
    const sub = e.target.closest('[data-sub-open]');
    if (sub) { const lvl = d.getElementById(sub.dataset.subOpen); if (lvl) { lvl.classList.add('is-active'); const b = $('.mnav__back', lvl); b && b.focus(); } }
    const back = e.target.closest('[data-sub-close]');
    if (back) { const lvl = back.closest('.mnav__level--sub'); lvl && lvl.classList.remove('is-active'); }
  });

  /* ---------- search ---------- */
  const sp = $('#SearchPanel');
  function openSearch() { if (!sp) return; closeMega(); sp.classList.add('is-open'); sp.setAttribute('aria-hidden', 'false'); syncTransparent(); setTimeout(() => $('input[type=search]', sp).focus(), 150); }
  function closeSearch() { if (!sp || !sp.classList.contains('is-open')) return; sp.classList.remove('is-open'); sp.setAttribute('aria-hidden', 'true'); syncTransparent(); }
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); sp && sp.classList.contains('is-open') ? closeSearch() : openSearch(); }));
  d.addEventListener('click', (e) => { if (sp && sp.classList.contains('is-open') && !sp.contains(e.target) && !e.target.closest('[data-search-toggle]')) closeSearch(); });
  if (sp) {
    const input = $('input[type=search]', sp); const out = $('#PredictiveResults', sp);
    let t, ctrl;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        ctrl && ctrl.abort(); ctrl = new AbortController();
        try {
          const r = await fetch(`${LUNA.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`, { signal: ctrl.signal });
          const html = await r.text();
          const tmp = d.createElement('div'); tmp.innerHTML = html;
          const res = $('#PredictiveInner', tmp);
          out.innerHTML = res ? res.innerHTML : '';
          initImages(out);
        } catch (err) { /* aborted */ }
      }, 220);
    });
  }

  /* ---------- images fade in ---------- */
  function initImages(scope = d) {
    $$('img.img-reveal', scope).forEach(img => {
      if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
      else { img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true }); img.addEventListener('error', () => img.classList.add('is-loaded'), { once: true }); }
    });
  }
  initImages();

  /* ---------- scroll reveal ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { threshold: 0.15 }) : null;
  function initReveal(scope = d) {
    $$('.grid, .rail', scope).forEach(g => {
      let i = 0; let prevTop = null;
      $$(':scope > .reveal', g).forEach(item => { item.style.setProperty('--d', ((i % 4) * 60) + 'ms'); i++; });
    });
    $$('.reveal:not(.is-in), .statement:not(.is-in)', scope).forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  }
  initReveal();

  /* ---------- hero ---------- */
  $$('.hero').forEach(h => {
    requestAnimationFrame(() => setTimeout(() => h.classList.add('is-ready'), 60));
    const media = $('.hero__media', h);
    if (!media || reduced || h.dataset.parallax !== 'true') return;
    const mq = window.matchMedia('(min-width: 990px)');
    window.addEventListener('scroll', () => {
      if (!mq.matches) { media.style.transform = ''; return; }
      const y = window.scrollY; if (y > h.offsetHeight) return;
      media.style.transform = `translate3d(0, ${y * 0.15}px, 0)`;
    }, { passive: true });
  });

  /* ---------- brand statement words ---------- */
  $$('.statement [data-words]').forEach(p => {
    const words = p.textContent.trim().split(/\s+/);
    const step = Math.min(40, Math.floor(1400 / Math.max(words.length, 1)));
    p.innerHTML = words.map((w, i) => `<span class="w" style="--i:${i * step / 40}">${w}</span>`).join(' ');
  });

  /* ---------- lookbook strip drag ---------- */
  $$('.strip').forEach(strip => {
    const bar = strip.parentElement.querySelector('.strip-progress span');
    const upd = () => { const max = strip.scrollWidth - strip.clientWidth; if (bar) bar.style.width = (max > 0 ? Math.max(8, (strip.scrollLeft / max) * 100) : 100) + '%'; };
    strip.addEventListener('scroll', upd, { passive: true }); upd();
    let down = false, sx = 0, sl = 0, moved = false;
    strip.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = strip.scrollLeft; strip.classList.add('is-dragging'); });
    window.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; strip.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', () => { down = false; strip.classList.remove('is-dragging'); });
    strip.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------- cart ---------- */
  const Cart = {
    async add(items) {
      const r = await fetch(LUNA.routes.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Błąd');
      this.render(data.sections && data.sections['cart-drawer']);
      return data;
    },
    async change(key, quantity) {
      const r = await fetch(LUNA.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer', sections_url: window.location.pathname }) });
      const data = await r.json();
      this.render(data.sections && data.sections['cart-drawer']);
      return data;
    },
    render(html) {
      if (!html) return;
      const tmp = d.createElement('div'); tmp.innerHTML = html;
      const nb = $('#CartDrawerBody', tmp); const ob = $('#CartDrawerBody');
      if (nb && ob) ob.replaceWith(nb);
      const count = $('[data-cart-count-src]', tmp);
      if (count) this.setCount(parseInt(count.dataset.cartCountSrc, 10));
      requestAnimationFrame(() => { const f = $('.ship-progress__fill'); if (f) { const w = f.dataset.w; f.style.width = w + '%'; } });
      initImages($('#CartDrawerBody') || d);
    },
    setCount(n) {
      $$('[data-cart-count]').forEach(el => { el.textContent = n; el.classList.remove('count-pulse'); void el.offsetWidth; el.classList.add('count-pulse'); });
    },
    open() { openDrawer($('#CartDrawer')); }
  };
  window.LunaCart = Cart;
  requestAnimationFrame(() => { const f = $('.ship-progress__fill'); if (f) f.style.width = f.dataset.w + '%'; });
  d.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-qty]');
    if (q) { e.preventDefault(); const line = q.closest('[data-key]'); await Cart.change(line.dataset.key, Math.max(0, parseInt(q.dataset.qty, 10))); $('#CartDrawer .drawer__head .close-x')?.focus(); return; }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      try { await Cart.add([{ id: parseInt(quick.dataset.quickAdd, 10), quantity: 1 }]); Cart.open(); }
      catch (err) { alert(err.message); }
      quick.disabled = false;
    }
  });

  /* ---------- product card: swipe dots, swatches, wishlist ---------- */
  const WL_KEY = 'luna-wishlist';
  const getWL = () => { try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e) { return []; } };
  const setWL = (a) => { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) { /* storage blocked */ } };
  function initCards(scope = d) {
    const wl = getWL();
    $$('.card__wish', scope).forEach(b => b.setAttribute('aria-pressed', wl.includes(b.dataset.handle) ? 'true' : 'false'));
    $$('.card__media--swipe', scope).forEach(m => {
      const dots = $$('.card__dots span', m.parentElement);
      if (!dots.length) return;
      m.addEventListener('scroll', () => { const i = Math.round(m.scrollLeft / m.clientWidth); dots.forEach((dt, k) => dt.classList.toggle('is-active', k === i)); }, { passive: true });
    });
  }
  initCards();
  d.addEventListener('click', (e) => {
    const w = e.target.closest('.card__wish');
    if (!w) return;
    e.preventDefault();
    let wl = getWL(); const h = w.dataset.handle;
    if (wl.includes(h)) { wl = wl.filter(x => x !== h); w.setAttribute('aria-pressed', 'false'); }
    else { wl.push(h); w.setAttribute('aria-pressed', 'true'); }
    setWL(wl);
  });
  const swapCard = (e) => {
    const s = e.target.closest('.card__swatches button'); if (!s || !s.dataset.img) return;
    const img = $('.card__img--1', s.closest('.card'));
    if (!img) return;
    img.style.opacity = 0;
    setTimeout(() => { img.srcset = ''; img.src = s.dataset.img; img.style.opacity = ''; }, 300);
  };
  d.addEventListener('mouseover', swapCard); d.addEventListener('focusin', swapCard);

  /* ---------- collection: filters, sort, density, load more ---------- */
  const coll = $('[data-collection]');
  if (coll) {
    const sectionId = coll.dataset.section;
    const grid = () => $('.grid', coll);
    async function load(url, push = true, append = false) {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      coll.classList.add('is-loading');
      const r = await fetch(u.toString());
      const html = await r.text();
      const tmp = d.createElement('div'); tmp.innerHTML = html;
      const next = $('[data-collection]', tmp);
      if (!next) { window.location.href = url; return; }
      if (append) {
        const items = $$('.grid > *', next);
        items.forEach((it, i) => { it.style.setProperty('--d', (i % 4) * 60 + 'ms'); grid().appendChild(it); });
        $('[data-pager]', coll).replaceWith($('[data-pager]', next));
      } else {
        const g = grid(); g && g.classList.add('is-switching');
        await new Promise(res => setTimeout(res, 200));
        ['[data-results]', '[data-count]', '[data-chips]', '#FilterForm', '[data-pager]', '[data-filter-show]'].forEach(sel => {
          const a = $(sel, coll); const b = $(sel, next);
          if (a && b) { if (sel === '#FilterForm') { $$('details', a).forEach((dt, i) => { const nd = $$('details', b)[i]; if (nd) nd.open = dt.open; }); } a.replaceWith(b); }
        });
        const showBtn = $('[data-filter-show]'); const nb = $('[data-filter-show]', tmp); if (showBtn && nb) showBtn.innerHTML = nb.innerHTML;
      }
      applyDensity();
      initImages(coll); initReveal(coll); initCards(coll); bindFilterForm();
      coll.classList.remove('is-loading');
      if (push) { u.searchParams.delete('section_id'); history.pushState({}, '', u.pathname + u.search); }
    }
    function formUrl(form) {
      const fd = new FormData(form); const p = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '') p.append(k, v); }
      const sort = $('[name=sort_by]', coll); if (sort && sort.value) p.set('sort_by', sort.value);
      return window.location.pathname + '?' + p.toString();
    }
    let ft;
    function bindFilterForm() {
      const form = $('#FilterForm');
      if (!form || form.dataset.bound) return; form.dataset.bound = '1';
      form.addEventListener('input', (e) => {
        if (e.target.type === 'range') { const box = e.target.closest('[data-price]'); syncRange(box, e.target); }
        clearTimeout(ft); ft = setTimeout(() => load(formUrl(form)), e.target.type === 'number' || e.target.type === 'range' ? 600 : 50);
      });
      form.addEventListener('submit', (e) => { e.preventDefault(); load(formUrl(form)); closeDrawer(); });
    }
    function syncRange(box, src) {
      if (!box) return;
      const [a, b] = $$('input[type=range]', box); const [na, nb] = $$('input[type=number]', box);
      if (+a.value > +b.value) { if (src === a) a.value = b.value; else b.value = a.value; }
      na.value = a.value; nb.value = b.value;
    }
    bindFilterForm();
    coll.addEventListener('click', (e) => {
      const a = e.target.closest('[data-ajax-link]');
      if (a) { e.preventDefault(); load(a.href); }
      const more = e.target.closest('[data-load-more]');
      if (more) { e.preventDefault(); more.disabled = true; load(more.dataset.loadMore, false, true); }
      const dens = e.target.closest('[data-density]');
      if (dens) { setDensity(dens.dataset.density); }
    });
    d.addEventListener('click', (e) => { const a = e.target.closest('#FilterDrawer [data-ajax-link]'); if (a) { e.preventDefault(); load(a.href); } });
    coll.addEventListener('change', (e) => { if (e.target.name === 'sort_by') { const f = $('#FilterForm'); load(f ? formUrl(f) : window.location.pathname + '?sort_by=' + e.target.value); } });
    window.addEventListener('popstate', () => load(window.location.href, false));
    function setDensity(v) {
      try { localStorage.setItem('luna-density', v); } catch (e) { /* noop */ }
      const g = grid(); if (!g) return;
      g.classList.add('is-switching');
      setTimeout(() => { applyDensity(); g.classList.remove('is-switching'); }, 200);
    }
    function applyDensity() {
      let v = 'normal'; try { v = localStorage.getItem('luna-density') || 'normal'; } catch (e) { /* noop */ }
      const g = grid(); if (!g) return;
      g.style.setProperty('--cols', v === 'dense' ? 4 : 2);
      g.style.setProperty('--cols-m', v === 'dense' ? 2 : 1);
      g.classList.toggle('cols-1', v !== 'dense');
      g.classList.remove('is-switching');
      $$('[data-density]', coll).forEach(b => b.setAttribute('aria-pressed', b.dataset.density === v ? 'true' : 'false'));
    }
    (function initDensity() { let v = null; try { v = localStorage.getItem('luna-density'); } catch (e) { /* noop */ } if (!v) { try { localStorage.setItem('luna-density', 'dense'); } catch (e) { /* noop */ } } applyDensity(); })();
  }

  /* ---------- accordions with height animation ---------- */
  d.addEventListener('click', (e) => {
    const sum = e.target.closest('details.acc > summary, details.facet > summary');
    if (!sum || reduced) return;
    const det = sum.parentElement; const body = det.querySelector('.acc__body');
    if (!body) return;
    e.preventDefault();
    if (det.open) {
      body.style.height = body.scrollHeight + 'px';
      requestAnimationFrame(() => { body.style.height = '0px'; });
      body.addEventListener('transitionend', () => { det.open = false; body.style.height = ''; }, { once: true });
    } else {
      det.open = true; const h = body.scrollHeight; body.style.height = '0px';
      requestAnimationFrame(() => { body.style.height = h + 'px'; });
      body.addEventListener('transitionend', () => { body.style.height = ''; }, { once: true });
    }
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach(pdp => {
    const json = $('script[data-product-json]', pdp); if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('#ProductForm', pdp) || $('form[action*="/cart/add"]', pdp);
    const idInput = $('input[name=id]', form);
    const selected = product.selected.slice();
    const btn = $('[data-atc]', pdp);
    const priceEl = $('[data-price]', pdp);
    const findVariant = () => product.variants.find(v => v.options.every((o, i) => o === selected[i]));
    function availableFor(idx, value) {
      return product.variants.some(v => v.available && v.options[idx] === value && v.options.every((o, i) => i === idx || i === product.sizeIndex || o === selected[i]));
    }
    function update() {
      const v = findVariant();
      $$('[data-opt]', pdp).forEach(b => {
        const idx = +b.dataset.idx; const val = b.dataset.opt;
        b.setAttribute('aria-checked', selected[idx] === val ? 'true' : 'false');
        b.classList.toggle('is-unavailable', !availableFor(idx, val));
      });
      $$('[data-opt-value]', pdp).forEach(s => { s.textContent = selected[+s.dataset.optValue] || ''; });
      const sizeChosen = product.sizeIndex < 0 || pdp.dataset.sizePicked === 'true' || product.options.length === 0;
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.innerHTML = v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s><span>${money(v.price)}</span>` : `<span>${money(v.price)}</span>`;
        const ok = v.available && sizeChosen;
        btn.disabled = !v.available;
        $('.atc-default', btn).textContent = !v.available ? 'Wyprzedane' : (sizeChosen ? 'Dodaj do koszyka' : 'Wybierz rozmiar');
        if (v.featured_image && product.colorIndex > -1) {
          const target = $(`[data-media-id="${v.featured_media_id}"]`, pdp);
          if (target && pdp.dataset.colorPicked === 'true' && window.matchMedia('(min-width: 990px)').matches) target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
        }
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
        const ss = $('[data-sticky-select]'); if (ss) ss.value = v.id;
      } else {
        btn.disabled = true; $('.atc-default', btn).textContent = 'Niedostępne';
      }
    }
    pdp.addEventListener('click', (e) => {
      const b = e.target.closest('[data-opt]'); if (!b) return;
      const idx = +b.dataset.idx;
      selected[idx] = b.dataset.opt;
      if (idx === product.sizeIndex) pdp.dataset.sizePicked = 'true';
      if (idx === product.colorIndex) pdp.dataset.colorPicked = 'true';
      update();
    });
    if (product.sizeIndex > -1 && product.variants.length === 1) pdp.dataset.sizePicked = 'true';
    if (new URL(window.location.href).searchParams.get('variant')) pdp.dataset.sizePicked = 'true';
    update();
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (product.sizeIndex > -1 && pdp.dataset.sizePicked !== 'true') {
        const s = $('[data-size-group]', pdp); s && s.querySelector('button')?.focus();
        $('.atc-default', btn).textContent = 'Wybierz rozmiar'; return;
      }
      btn.disabled = true;
      try {
        await Cart.add([{ id: parseInt(idInput.value, 10), quantity: 1 }]);
        btn.classList.add('is-added');
        setTimeout(() => { btn.classList.remove('is-added'); btn.disabled = false; Cart.open(); }, 1500);
      } catch (err) { btn.disabled = false; alert(err.message); }
    });
    // sticky ATC (mobile)
    const sticky = $('.sticky-atc');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(btn);
      sticky.addEventListener('submit', async (e) => {
        e.preventDefault();
        const id = $('[data-sticky-select]', sticky).value;
        try { await Cart.add([{ id: parseInt(id, 10), quantity: 1 }]); Cart.open(); } catch (err) { alert(err.message); }
      });
    }
    // mobile gallery counter
    const gal = $('.pdp__gallery', pdp); const counter = $('.pdp__counter', pdp); const prog = $('.pdp__progress span', pdp);
    if (gal && counter) {
      const n = gal.children.length;
      const upd = () => { const i = Math.round(gal.scrollLeft / gal.clientWidth) + 1; counter.textContent = `${i} / ${n}`; if (prog) prog.style.width = (i / n * 100) + '%'; };
      gal.addEventListener('scroll', upd, { passive: true }); upd();
    }
  });

  /* ---------- zoom viewer ---------- */
  const zoom = $('#ZoomViewer');
  let zoomReturn = null;
  function closeZoom() { if (!zoom) return; zoom.classList.remove('is-open'); zoom.setAttribute('aria-hidden', 'true'); d.body.style.overflow = ''; zoomReturn && zoomReturn.focus(); }
  if (zoom) {
    const zi = $('img', zoom);
    const pan = (x, y) => {
      const w = zi.offsetWidth, h = zi.offsetHeight, vw = zoom.clientWidth, vh = zoom.clientHeight;
      const tx = -(x / vw) * Math.max(0, w - vw); const ty = -(y / vh) * Math.max(0, h - vh);
      zi.style.transform = `translate3d(${tx}px, ${ty}px, 0)`;
    };
    d.addEventListener('click', (e) => {
      const z = e.target.closest('[data-zoom]');
      if (!z || !window.matchMedia('(min-width: 990px)').matches) return;
      zoomReturn = z; zi.src = z.dataset.zoom; zi.alt = z.dataset.alt || '';
      zoom.classList.add('is-open'); zoom.setAttribute('aria-hidden', 'false'); d.body.style.overflow = 'hidden';
      pan(zoom.clientWidth / 2, zoom.clientHeight / 2);
      $('.close-x', zoom).focus();
    });
    zoom.addEventListener('mousemove', (e) => pan(e.clientX, e.clientY));
    zoom.addEventListener('click', (e) => { closeZoom(); });
  }

  /* ---------- shop the look hotspots ---------- */
  d.addEventListener('click', (e) => {
    const h = e.target.closest('.hotspot');
    $$('.hotcard.is-open').forEach(c => { if (!h || c.id !== h.getAttribute('aria-controls')) { c.classList.remove('is-open'); const t = d.querySelector(`[aria-controls="${c.id}"]`); t && t.setAttribute('aria-expanded', 'false'); } });
    if (h) { const c = d.getElementById(h.getAttribute('aria-controls')); if (c) { const open = !c.classList.contains('is-open'); c.classList.toggle('is-open', open); h.setAttribute('aria-expanded', open ? 'true' : 'false'); } }
  });

  /* ---------- newsletter: keep success visible ---------- */
  $$('[data-newsletter-success]').forEach(el => el.scrollIntoView && setTimeout(() => el.scrollIntoView({ block: 'center' }), 200));

  /* ---------- cookie banner (Customer Privacy API) ---------- */
  const cookie = $('#CookieBanner');
  if (cookie) {
    const show = () => {
      const api = window.Shopify && window.Shopify.customerPrivacy;
      if (api && typeof api.shouldShowBanner === 'function' ? api.shouldShowBanner() : !localStorage.getItem('luna-cookie')) cookie.classList.add('is-visible');
    };
    const decide = (yes) => {
      const api = window.Shopify && window.Shopify.customerPrivacy;
      const consent = { analytics: yes, marketing: yes, preferences: yes, sale_of_data: yes };
      if (api && api.setTrackingConsent) api.setTrackingConsent(consent, () => {});
      try { localStorage.setItem('luna-cookie', yes ? 'all' : 'necessary'); } catch (e) { /* noop */ }
      cookie.classList.remove('is-visible');
    };
    $('[data-cookie-accept]', cookie).addEventListener('click', () => decide(true));
    $('[data-cookie-decline]', cookie).addEventListener('click', () => decide(false));
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (err) { try { if (!localStorage.getItem('luna-cookie')) cookie.classList.add('is-visible'); } catch (e) { /* noop */ } return; } show(); });
    } else { try { if (!localStorage.getItem('luna-cookie')) cookie.classList.add('is-visible'); } catch (e) { /* noop */ } }
  }

  /* ---------- theme editor ---------- */
  if (window.Shopify && window.Shopify.designMode) {
    d.addEventListener('shopify:section:load', (e) => { initImages(e.target); initReveal(e.target); initCards(e.target); $$('.reveal', e.target).forEach(x => x.classList.add('is-in')); $$('.hero', e.target).forEach(h => h.classList.add('is-ready')); });
  }
})();
